import { CountDown, Note, Page } from "../../../../helbest";
import { useLocation, useParams } from "react-router-dom";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import DoneImg from "../../../../assets/images/base/done.png";
import CancelImg from "../../../../assets/images/base/cancel.png";
import Steps from "../Steps/Steps";
import styles from "./Verification.module.css";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { API } from "../../../../request/api";
import { Button } from "antd";
import OtpInput from "../../../../helbest/OtpInput/OtpInput";
import OtpServiceDrawer from "../../../components/OtpServiceDrawer/OtpServiceDrawer";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
import { reset_service_state } from "../../../../store/actions/services_actions";
import { useDispatch } from "react-redux";

export const Verification = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { availableOtp } = location.state;
  const [step, setStep] = useState(1);
  const [errorCount, setErrorCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [otp, setOtp] = useState("");
  const navigate = useLangNavigate();
  const params = useParams();
  const [resendCodeActive, setResendCodeActive] = useState(false);
  const { t } = useTranslation();
  const [resetKey, setResetKey] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempOtp, setTempOtp] = useState(() => {
    return (
      availableOtp?.find((service) => service.isDefault) || availableOtp?.[0]
    );
  });

  useEffect(() => {
    if (!availableOtp) {
      navigate(-1);
    }
  }, [availableOtp]);

  const onInput = (value) => {
    setOtp(value.join(""));
  };

  const onChange = (value) => {
    onSubmit(value);
  };

  const showDataByStatus = () => {
    switch (status) {
      case "done":
        return {
          title: t("services.completed"),
          image: DoneImg,
          color: "#06DF70",
        };
      case "cancel":
        return {
          title: t("services.failed"),
          image: CancelImg,
          color: "#FF0000",
        };
      default:
        return {};
    }
  };

  const onSubmit = (otpCode) => {
    setLoading(true);
    API.post
      .otpValidationOnService(otpCode, params.phone, params.id)
      .then((response) => {
        setLoading(false);
        if (response.code === 200) {
          Note.success(response.message);
          setStep(2);
          setStatus("done");
        }
        if (response.code === 400) {
          Note.error(response.message);
          if (errorCount < 2) {
            setErrorCount((prev) => prev + 1);
          } else {
            setStep(2);
            setStatus("cancel");
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        Note.success(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resendOtpCode = (messagingService) => {
    setResendCodeActive(false);
    setErrorCount(0);
    API.post
      .resendOtpValidationOnService(params.phone, messagingService)
      .then((response) => {
        if (response.success) {
          Note.success(response.message);
        } else {
          Note.error(response.message);
        }
      })
      .catch((error) => {
        Note.success(error.message);
      });
  };

  const resetCountdown = () => {
    setResetKey((prev) => prev + 1);
  };


 const goBackToNewService = () => {
  dispatch(reset_service_state());
  navigate("/new-service/");
};

  return (
    <Page
      showFooter
      body
      customHeader={
        <HeaderBack title={t("drawer.new_service")} url={"/select-service/"} />
      }
      extra_header={<Steps step={step === 2 ? 4 : 3} open={true} locked={step === 2} />}
      customPageClassName={styles.verifyPage}
      headerFix
      logo
      noFooter
      back
    >
      {step === 1 ? (
        <>
          <div className={styles.otpSection}>
            <p className={styles.otpText}>
              <Trans
                i18nKey="sendOtp.verification"
                components={[
                  <span dir="ltr">{params.phone}</span>, <span>
                    {availableOtp.find((item) => item.value === tempOtp.value)
                      ?.label || availableOtp[0].label}
                  </span>,
                ]}
              />
            </p>
            <OtpInput value={otp} onInput={onInput} onChange={onChange} />
            <div className={styles.otpActions}>
              {!resendCodeActive ? (
                <div className={styles.otpCountDown}>
                  <CountDown
                    key={resetKey}
                    className="page-login-counter"
                    time={120000}
                    onTimeUp={() => {
                      setResendCodeActive(true);
                    }}
                  />
                </div>
              ) : null}
              <p className={styles.resendText}>
                {t("sendOtp.no_receive")}{" "}
                <span
                  className={
                    resendCodeActive ? styles.resendLink : styles.resendLinkDisabled
                  }
                  onClick={() => {
                    if (resendCodeActive) setIsModalOpen(true);
                  }}
                >
                  {t("sendOtp.re-send")}
                </span>
              </p>
            </div>
          </div>
          <div className="page-fixed-footer-container">
            <Button
              loading={loading}
              htmlType="submit"
              type="primary"
              size="large"
              style={{
                width: "100%",
              }}
            >
              {t("common.next")}
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="w-full flex flex-column justify-center items-center">
            <img
              width={200}
              src={showDataByStatus()?.image}
              alt="verificitation-status"
            />
            <span
              className={styles.message}
              style={{ color: showDataByStatus()?.color }}
            >
              {showDataByStatus()?.title}
            </span>
          </div>

          <div className="page-fixed-footer-container">
            <Button
              onClick={goBackToNewService}
              type="primary"
              size="large"
              style={{
                width: "100%",
                maxWidth: "300px",
              }}
            >
              {t("new_service.back_to_service_page")}
            </Button>
          </div>
        </>
      )}
      <OtpServiceDrawer
        open={isModalOpen}
        setOpen={setIsModalOpen}
        onSelect={(service) => {
          setTempOtp(service);
          setIsModalOpen(false);
          resetCountdown();
          resendOtpCode(service.value);
        }}
        options={availableOtp?.filter((option) => option.isDefault)}
      />
    </Page>
  );
};
